/** Public App Store listing for the CardPass iOS app (bundle co.cardpass.app). */
export const APP_STORE_URL = 'https://apps.apple.com/app/id6813832210';
